export const functions = [
    "agriculteur",

    "revendeur",

    "distributeur",

    "consultant",

    "inspecteur",

    "autre",

]; 